/* Cart drawer behaviour (RR). Delegated handlers so the drawer can be re-rendered freely.
   Quantity, remove, add-a-suggestion and swap-to-Extended all go through Shopify's cart endpoints and
   re-render the drawer + header bubble via the Section Rendering API. */
(function () {
  'use strict';
  if (window.__rrCart) return; window.__rrCart = true;
  const pageEl = () => document.querySelector('[data-rr-cart-page]');
  const pageSectionId = () => { const p = pageEl(); const s = p && p.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; };
  const SECTIONS = () => ['cart-drawer', 'cart-icon-bubble', pageSectionId()].filter(Boolean).join(',');
  const drawer = () => document.querySelector('cart-drawer');

  function paint(sections, itemCount) {
    const d = drawer();
    const parse = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    if (d && sections['cart-drawer']) {
      const inner = parse(sections['cart-drawer'], '#CartDrawer');
      const target = d.querySelector('#CartDrawer');
      if (inner && target) { target.innerHTML = inner.innerHTML; target.querySelector('#CartDrawer-Overlay').addEventListener('click', () => d.close()); }
      if (itemCount !== undefined) d.classList.toggle('is-empty', itemCount === 0);
    }
    const bubble = document.querySelector('#cart-icon-bubble'), nb = parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && nb) bubble.innerHTML = nb.innerHTML;
    const pid = pageSectionId();
    if (pid && sections[pid]) { const np = parse(sections[pid], '[data-rr-cart-page]'); const cp = pageEl(); if (np && cp) cp.replaceWith(np); }
    if (window.RINO && window.RINO.cart !== undefined) { fetch('/cart.js').then(r => r.json()).then(c => { window.RINO.cart = c; }).catch(() => {}); }
  }
  async function post(url, body) {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ ...body, sections: SECTIONS(), sections_url: location.pathname }) });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
    return j;
  }
  function busy(el, on) { const it = el && el.closest('.rc-item'); if (it) it.classList.toggle('is-busy', on); }
  function fail(msg) { const e = document.querySelector('#CartDrawer-CartErrors'); if (e) e.textContent = msg; }

  /* Express checkout: Shopify lists wallets in the shopper's preferred order. Show the first one under
     Checkout, keep the rest behind "More ways to pay". Two fresh components, each with its own list. */
  function splitWallets(root) {
    (root || document).querySelectorAll('[data-rr-express-more]').forEach(more => {
      /* split once per container: the wallet component re-renders itself when the details opens, and re-splitting
         that fresh element would mutate the DOM in a loop (Michael's "More ways to pay" freeze) */
      if (more.dataset.rrSplit) return;
      const top = more.parentElement.querySelector('[data-rr-express-top]');
      const el = more.querySelector('shopify-accelerated-checkout-cart');
      if (!top || !el || el.dataset.rrSplit) return;
      more.dataset.rrSplit = '1';
      let cfgs; try { cfgs = JSON.parse(el.getAttribute('wallet-configs') || '[]'); } catch (e) { return; }
      el.dataset.rrSplit = '1';
      if (cfgs.length < 2) { top.appendChild(el.parentElement); more.hidden = true; return; }
      const make = list => { const c = document.createElement(el.tagName.toLowerCase()); [...el.attributes].forEach(a => c.setAttribute(a.name, a.value)); c.setAttribute('wallet-configs', JSON.stringify(list)); c.dataset.rrSplit = '1'; return c; };
      const wrap = document.createElement('div'); wrap.className = 'dynamic-checkout__content'; wrap.setAttribute('data-shopify', 'dynamic-checkout-cart');
      wrap.appendChild(make([cfgs[0]])); top.appendChild(wrap);
      el.replaceWith(make(cfgs.slice(1)));
    });
  }
  splitWallets();
  /* Pre-order lines without their ship date (added from a page or button that does not attach it): add the date, so the
     cart, checkout and the order all say when each line ships. One attempt per line key; lines that end up identical merge. */
  const healed = new Set(); let healing = false;
  async function healShips() {
    if (healing) return; const need = [...document.querySelectorAll('.rc-item[data-needs-ships]')].filter(i => !healed.has(i.dataset.key));
    if (!need.length) return; healing = true;
    try {
      let j;
      const cart = await fetch('/cart.js').then(r => r.json());
      for (const it of need) {
        /* keep whatever properties the line already has: Shopify replaces the whole properties object on change */
        const line = (cart.items || []).find(x => x.key === it.dataset.key); const props = Object.assign({}, line && line.properties || {}, { Ships: it.dataset.needsShips });
        j = await post('/cart/change.js', { id: it.dataset.key, quantity: +it.dataset.qty || 1, properties: props });
        healed.add(it.dataset.key); /* marked only once the change went through, so a failed line is retried next pass */
      }
      if (j) paint(j.sections, j.item_count);
    } catch (e) { /* leave the line as it is; the reassurance list still states the ship date */ }
    healing = false;
  }
  healShips();
  /* watch the cart surfaces only (section re-renders replace them), and coalesce bursts of mutations into one pass */
  let splitQueued = false;
  const queueSplit = () => { if (splitQueued) return; splitQueued = true; requestAnimationFrame(() => { splitQueued = false; splitWallets(); healShips(); }); };
  new MutationObserver(muts => {
    if (muts.some(m => [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-rr-express-more], cart-drawer, .rr-cart, .drawer__inner') || n.querySelector('[data-rr-express-more]'))))) queueSplit();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-rr-qty]'), rm = e.target.closest('[data-rr-remove]'), add = e.target.closest('[data-rr-add]'), swap = e.target.closest('[data-rr-swap]');
    if (!q && !rm && !add && !swap) return;
    e.preventDefault();
    try {
      if (q || rm) {
        const item = (q || rm).closest('.rc-item'); const line = +item.dataset.line;
        const current = +item.querySelector('.qty span')?.textContent || 1;
        const quantity = rm ? 0 : Math.max(0, current + (+q.dataset.rrQty));
        busy(item, true);
        const j = await post('/cart/change.js', { line, quantity });
        paint(j.sections, j.item_count);
      } else if (add) {
        add.disabled = true;
        const addItem = { id: +add.dataset.rrAdd, quantity: 1 }; if (add.dataset.rrShips) addItem.properties = { Ships: add.dataset.rrShips };
        const j = await post('/cart/add.js', { items: [addItem] });
        paint(j.sections, undefined);
        const c = await fetch('/cart.js').then(r => r.json()); const dd = drawer(); if (dd) dd.classList.toggle('is-empty', c.item_count === 0);
      } else if (swap) {
        swap.disabled = true;
        const line = +swap.dataset.line; const item = document.querySelector(`.rc-item[data-line="${line}"]`); busy(item, true);
        const qty = +item.querySelector('.qty span')?.textContent || 1;
        const swapItem = { id: +swap.dataset.rrSwap, quantity: qty }; if (swap.dataset.rrShips) swapItem.properties = { Ships: swap.dataset.rrShips };
        /* add the replacement first, then take the original out by its key: a failed add leaves the cart exactly as it was,
           and a failed removal leaves both lines visible rather than neither */
        const before = await fetch('/cart.js').then(r => r.json()); const old = (before.items || [])[line - 1];
        const j1 = await post('/cart/add.js', { items: [swapItem] });
        if (!old) { paint(j1.sections, undefined); return; }
        try {
          const j2 = await post('/cart/change.js', { id: old.key, quantity: 0 });
          paint(j2.sections, j2.item_count);
        } catch (e2) {
          paint(j1.sections, undefined); fail('Extended was added, but the Standard line could not be removed. Remove it below.');
        }
      }
    } catch (err) { fail(err.message); }
    finally { document.querySelectorAll('.rc-item.is-busy').forEach(i => i.classList.remove('is-busy')); document.querySelectorAll('[data-rr-add],[data-rr-swap]').forEach(b => { b.disabled = false; }); }
  });
})();
